module.exports = __webpack_public_path__ + "static/media/slack-hover.0a7d998e.svg";